module.exports = __webpack_public_path__ + "assets/icon-conductor-ironWire.31909313.svg";